import { render, staticRenderFns } from "./AccountBasicInfo.vue?vue&type=template&id=5ac85862"
import script from "./AccountBasicInfo.vue?vue&type=script&lang=js"
export * from "./AccountBasicInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports